'use client';

import { useState } from 'react';
import { QuickActivityForm } from '../activity/QuickActivityForm';

function QuickAddBtn({ title }) {
  const [modal, setModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setModal(true)}
        type='button'
        className='btn btn-primary btn-sm'
        style={{ fontSize: '12px', padding: '6px 12px' }}
      >
        <i className='fas fa-code-branch me-1' style={{ fontSize: '11px' }} />
        {title}
      </button>
      <QuickActivityForm modal={modal} setModal={setModal} />
    </>
  );
}

export default QuickAddBtn;
